import React from "react";
import Avatar from '@material-ui/core/Avatar';

function AvatarIcon({profile_photo="",width=40,heigth=40,isgroup=false,style}){
    return(
        <Avatar alt="Remy Sharp" src={profile_photo} heigth={heigth} width={width} style={style}/>
    )
}
export default AvatarIcon;